<template>
    <section class="section-padding">
        <div class="container" id="container-banner">
            <div class="buy-sell-car mt-5">
                <div class="act-car-img">
                    <img
                        src="assets/images/slider/mb_gle.wepb"
                        alt="image"
                    />
                </div>
                <div class="new-car act-car">
                    <h2 class="mb-0">
                        <a href="/compra_de_usados" class="text-act-car">
                            Comprar</a
                        >
                    </h2>
                </div>
                <div class="old-car act-car">
                    <h2 class="mb-0">
                        <a href="/vender" class="text-act-car"
                            >Vender
                        </a>
                    </h2>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style lang="scss">
div#container-banner {
    padding: 140px 0;
}

a.text-act-car {
    color: #ffffff;
    text-shadow: 2px 0px 0 #160101;
    text-transform: uppercase;
}
</style>
